module.exports = __webpack_public_path__ + "static/media/clock1.26dfa350.png";